import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Link, Divider } from '@material-ui/core'
import ScrollAnimation from 'react-animate-on-scroll'
import 'animate.css/animate.min.css'
import GitHubIcon from '@material-ui/icons/GitHub'
import Bestwestern from '../Img/bestwestern.gif'
import Church from '../Img/church.gif'
import Wearther from '../Img/wearther.gif'
import Maxprod from '../Img/maxprod.gif'
import {
  COLOR_FONT,
  COLOR_HIGH,
  COLOR_MID,
  SPACING_BIG,
  SPACING_MED,
  SPACING_XBIG,
  SPACING_SMALL,
  SPACING_XSMALL,
} from '../constants'

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: SPACING_MED,
    marginBottom: SPACING_BIG,
    marginRight: SPACING_MED,
    color: COLOR_FONT,
    [theme.breakpoints.up('md')]: {
      marginLeft: '15%',
      marginRight: '15%',
    },
  },
  title: {
    color: COLOR_HIGH,
    marginTop: SPACING_XBIG,
    paddingTop: SPACING_MED,
  },
  subtitle: {
    color: COLOR_MID,
    marginTop: SPACING_BIG,
    marginBottom: SPACING_XSMALL,
  },
  subtitle2: { marginTop: SPACING_SMALL, marginBottom: SPACING_SMALL },
  desc: { marginBottom: SPACING_XSMALL },
  link: { color: COLOR_HIGH, marginRight: SPACING_XSMALL },
  imgholder: {
    width: '100%',
    display: 'inline-block',
    marginBottom: SPACING_XSMALL,
  },
  img: {
    maxWidth: '600px',
    width: '100%',
    height: 'auto',
  },
}))

function Projects() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography
          variant="h3"
          component="h3"
          className={classes.title}
          id={'projects'}
        >
          PROJECT
        </Typography>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Working hours calculator for Best Western
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          June 2018
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Bestwestern} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed web application with React JS and Material-UI
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Calculate working hours for biweekly payroll
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Mobile friendly
        </Typography>
        <Link href="/bestwestern" className={classes.link}>
          DEMO
        </Link>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Website for Edmonton Central Korean Presbyterian Church
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          March 2020
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Church} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed a church website with React JS and Material-UI
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Mobile friendly
        </Typography>
        <Link
          href="https://github.com/ryanwlee/edmonton-central-korean-presbyterian-church"
          className={classes.link}
        >
          <GitHubIcon />
        </Link>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Max Prod
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          November 2019
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Maxprod} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;“time blocking” method tool helping you to make maximum
          productivity
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;MERN stack (MongoDB, Express, React, Node)
        </Typography>
        <Link
          href="https://github.com/ryanwlee/maxprod"
          className={classes.link}
        >
          <GitHubIcon />
        </Link>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Wearther
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          October 2019
        </Typography>
        <Divider />
        <div className={classes.imgholder}>
          <img src={Wearther} alt={''} className={classes.img} />
        </div>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed web application with React JS
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Fetch current weather data based on user location and
          suggest clothes appropriate to the temperature
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Mobile friendly
        </Typography>
        <Link href="https://glitch.com/~wearther" className={classes.link}>
          DEMO
        </Link>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Speech to Text using IBM Watson API
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          March 2017
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed desktop application with Java, JSON, and IBM
          Watson API
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Won “Best Desktop Application” for IBM Future Blue 2016
          Hackathon
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;The application converts voice from web conferences to
          test simultaneously for people with hearing loss, non-English
          speakers, and text meeting reports
        </Typography>
        <Link
          href="https://github.com/ryanwlee/hackathon"
          className={classes.link}
        >
          <GitHubIcon />
        </Link>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Picky Monkey
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          December 2015 - February 2016
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed free-for-sale web application specifically for
          university student communities across the world
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed with PHP, JavaScript, HTML / CSS, SQL, and
          Osclass
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;The application was live from February 2016 to May 2016
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Design Project from University of Toronto
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          January 2015 - April 2015
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Built Facebook Q/A application for users who are
          interested in real estate topics
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Developed with open source OSQA on VPC server using
          Python, JavaScript, and PostgreSQL
        </Typography>
      </ScrollAnimation>
      <ScrollAnimation animateIn="fadeIn" offset={50}>
        <Typography variant="h4" component="h4" className={classes.subtitle}>
          Search Engine project from University of Toronto
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.subtitle2}
        >
          March 2015
        </Typography>
        <Divider />
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Built a search engine using Python
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Used Crawler to grab information from websites
        </Typography>
        <Typography
          variant="body1"
          display="block"
          gutterBottom
          className={classes.desc}
        >
          &#8226;&nbsp;Received bonus marks by implementing ranking algorithm to
          show accurate search results and multi-thread programming for better
          performance
        </Typography>
        <Link
          href="https://github.com/ryanwlee/python_search_engine"
          className={classes.link}
        >
          <GitHubIcon />
        </Link>
      </ScrollAnimation>
    </div>
  )
}

export default Projects
